export const average = (arr) => arr.reduce((sum, el) => sum + el, 0) / arr.length;

export const max = (arr) => Math.max(...arr);
